import { useContext } from 'react'

import PhishingContext from 'contexts/PhishingContext'

const usePhishing = () => {
  const context = useContext(PhishingContext)

  if (context === undefined) {
    throw new Error(
      'usePhishing must be used within a PhishingContext.Provider',
    )
  }

  return {
    activeButton: context.activeButton,
    activeStep: context.activeStep,
    handleAdvanceStep: context.handleAdvanceStep,
    handleBack: context.handleBack,
    handleNext: context.handleNext,
    handleReturnStep: context.handleReturnStep,
    handleStep: context.handleStep,
    isCompleted: context.isCompleted,
    isReadOnly: context.isReadOnly,
    phishing: context.phishing,
    setIsReadOnly: context.setIsReadOnly,
    resetAdvanceStep: context.resetAdvanceStep,
    resetReturnStep: context.resetReturnStep,
    setActiveButton: context.setActiveButton,
    setActiveStep: context.setActiveStep,
    setLastActiveStep: context.setLastActiveStep,
    setPhishing: context.setPhishing,
    setShowButtons: context.setShowButtons,
    showButtons: context.showButtons,
    wantsToAdvanceStep: context.wantsToAdvanceStep,
    wantsToReturnStep: context.wantsToReturnStep,
  }
}

export default usePhishing
